import { toast } from "sonner";
import { Copy, KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { loginDetailsText, driverLoginText } from "@/lib/password";

export const CredentialsDialog = ({ creds, onClose, who = "driver" }) => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(creds.username ? driverLoginText(creds.username, creds.password) : loginDetailsText(creds.email, creds.password));
      toast.success("Login details copied");
    } catch {
      toast.error("Could not copy. Select the text and copy it manually.");
    }
  };
  return (
    <Dialog open={!!creds} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="credentials-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><KeyRound className="w-5 h-5 text-[#002FA7]" /> {creds?.title}</DialogTitle>
          <DialogDescription>{creds?.username ? "Send these to the driver. They sign in at the driver login page. You can view the password again on their profile." : `Send these to the ${who} now. The password will not be shown again.`}</DialogDescription>
        </DialogHeader>
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 space-y-3">
          <div>
            <div className="text-xs uppercase tracking-wider text-slate-500">{creds?.username ? "Username" : "Email"}</div>
            <div className="font-medium break-all" data-testid="credentials-email">{creds?.username || creds?.email}</div>
          </div>
          {creds?.username && (
            <div>
              <div className="text-xs uppercase tracking-wider text-slate-500">Driver sign-in page</div>
              <div className="text-sm break-all" data-testid="credentials-login-url">{`${window.location.origin}/driver-login`}</div>
            </div>
          )}
          <div>
            <div className="text-xs uppercase tracking-wider text-slate-500">Password</div>
            <div className="font-mono text-lg font-semibold" data-testid="credentials-password">{creds?.password}</div>
          </div>
        </div>
        {creds?.email_sent === true && <p className="text-sm text-emerald-700" data-testid="credentials-email-sent">A welcome email with the sign-in link was sent to {creds.email}. For security it doesn't include the password, so share the password yourself.</p>}
        {creds?.email_sent === false && <p className="text-sm text-amber-700" data-testid="credentials-email-failed">The welcome email couldn't be sent. Share the sign-in link and details yourself.</p>}
        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="outline" onClick={onClose} data-testid="credentials-done-btn">Done</Button>
          <Button onClick={copy} className="bg-[#002FA7] hover:bg-[#001A75]" data-testid="copy-login-btn">
            <Copy className="w-4 h-4 mr-1.5" /> Copy login details
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
